export const CUSTOM_GROUP_ID = -4;